import React, { type PropsWithChildren } from 'react';

import { CarouselDirections, CarouselThemes } from '../consts';

const INITIAL_STATE = {
    carousel: {
        hovered: false,
        direction: CarouselDirections.RIGHT,
        titleHovered: false,
        titleMessageId: null,
        theme: CarouselThemes.LIGHT,
    },
    sectionNavigation: {
        hovered: false,
    },
    appDevelopmentService: {
        hovered: false,
        tooltipMessageId: null,
    },
    article: {
        hovered: false,
        tooltipMessageId: 'wroteAboutUs.fullArticle',
    },
    anyDarkSection: {
        hovered: false,
    },
};

export type HoverContextState = typeof INITIAL_STATE;
export type SetHoverContextState = (state: HoverContextState) => void;

const HoverContext = React.createContext<{ context: HoverContextState; setContext: SetHoverContextState }>({
    context: INITIAL_STATE,
    setContext: () => {},
});

const HoverProvider = ({ children }: PropsWithChildren) => {
    const [state, setState] = React.useState(INITIAL_STATE);

    return (
        <HoverContext.Provider
            value={{
                context: state,
                setContext: setState,
            }}
        >
            {children}
        </HoverContext.Provider>
    );
};

const HoverConsumer = HoverContext.Consumer;

export { HoverProvider, HoverConsumer, HoverContext };
